import React, { useEffect, useState } from "react";
import { getFiles } from "API/swesum";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

import { useNavigate } from "react-router-dom";
import FilesTable from "./components/FilesTable";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function Files() {
  const { openError } = usePopupNotificationContext();
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const asyncFetchFiles = async () => {
      setLoading(true);
      try {
        const files = await getFiles();
        setFiles(files);
      } catch (err) {
        console.err(err);
        openError("Någonting gick fel", 3000);
      } finally {
        setLoading(false);
      }
    };
    asyncFetchFiles();
  }, []);

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "1.0rem",
              }}
            >
              <Typography variant="h5">Filer</Typography>
              <Button
                onClick={() => navigate("upload")}
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
              >
                Skapa ny
              </Button>
            </Box>
            <FilesTable loading={loading} files={files} />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
